// Menu icons standardised on react-icons (react-icons/fa = the same FontAwesome 5
// glyphs, so this is a 1:1 visual swap). Icon values below are component references
// (e.g. `icon: FaChartPie`); the nav renderer renders them directly. The `@fortawesome/*`
// packages have been fully removed — use react-icons for any new icons here.
import {
  FaFlag, FaChartPie, FaCalendarAlt, FaCar, FaPlane, FaUser, FaUserLock,
  FaAddressBook, FaFileSignature, FaBalanceScale, FaUniversalAccess, FaUsers, FaBuilding,
  FaUserFriends, FaUserShield, FaUserAstronaut, FaBell, FaPlug, FaTools,
  FaQuestionCircle, FaCodeBranch, FaBookOpen, FaRobot, FaBrain, FaGoogleDrive,
  FaWarehouse, FaSitemap, FaChartLine, FaVrCardboard, FaBoxes,
  FaShoppingCart, FaMoneyBillWave, FaFileInvoice, FaFileContract, FaBookDead,
  FaIntercom, FaRProject, FaTruck, FaBoxOpen, FaRoute, FaShieldAlt, FaTrophy,
  FaInbox, FaThLarge, FaHandHoldingUsd, FaFileInvoiceDollar, FaBriefcase,
  FaEdit, FaHandPaper, FaListUl, FaUserCheck, FaCalendarCheck, FaCommentDots,
  FaTable, FaBox, FaClipboardList, FaDolly, FaMapMarkedAlt, FaCertificate,
  FaDollarSign, FaClipboardCheck, FaTasks, FaFileAlt, FaClipboard,
  FaCalendarPlus, FaCog, FaCarSide, FaIdCard,
  FaPlaneDeparture, FaMoneyCheckAlt, FaProjectDiagram, FaUserPlus, FaHistory,
} from "react-icons/fa";


export const homeRoutes = {
  label: "Home",
  children: [
    {
      name: "Starter",
      icon: FaFlag,
      to: "/",
      active: true
    },
    {
      name: "Profile",
      to: "/user/profile",
      active: true
    },
    {
      name: "Privacy policy",
      to: "/privacy-policy",
      active: true
    },
    {
      name: "Terms of service",
      to: "/terms-of-service",
      active: true
    }
  ]
};

// Dashboards are grouped by business domain under a single "Dashboard" section.
// Each domain (CRM today; ERP / Logistics / HR as they ship) is its own
// collapsible group, with that domain's consolidated "Overview" first, then the
// individual dashboards in sales-lifecycle order. To add a new domain, append a
// sibling group to `children` (see the commented template at the bottom) — no
// nav code changes are needed (NavbarVerticalMenu renders groups recursively).
export const dashboardRoutes = {
  label: "Dashboard",
  children: [
    {
      name: "CRM",
      icon: FaChartPie,
      permissionNo: "v500",
      active: true,
      children: [
        {
          name: "Overview",
          icon: FaThLarge,
          to: "/dashboard/crm",
          permissionNo: "v513",
          active: true,
          badge: { type: "danger", text: "New" }
        },
        {
          name: "Sales",
          icon: FaHandHoldingUsd,
          to: "/dashboard/crm/sales",
          permissionNo: "v508",
          active: true,
          badge: { type: "danger", text: "New" }
        },
        {
          name: "Quotation",
          icon: FaFileInvoiceDollar,
          to: "/dashboard/crm/quotation",
          permissionNo: "v511",
          active: true
        },
        {
          name: "Job entry",
          icon: FaBriefcase,
          to: "/dashboard/crm/job-entry",
          permissionNo: "v512",
          active: true
        },
        {
          name: "Contract",
          icon: FaFileContract,
          to: "/dashboard/crm/contract",
          permissionNo: "v509",
          active: true
        },
        {
          name: "Change order",
          icon: FaEdit,
          to: "/dashboard/crm/change-order",
          permissionNo: "v507",
          active: true
        },
        {
          name: "Waiver",
          icon: FaHandPaper,
          to: "/dashboard/crm/waiver",
          permissionNo: "v510",
          active: true
        },
        {
          name: "Logistic",
          icon: FaTruck,
          to: "/dashboard/crm/logistic",
          permissionNo: "v517",
          active: true
        }
      ]
    },
    {
      name: "Booking",
      icon: FaCalendarAlt,
      active: true,
      children: [
        {
          name: "Car",
          icon: FaCar,
          to: "/dashboard/booking/car",
          permissionNo: "v514",
          active: true
        },
        {
          name: "Travel",
          icon: FaPlane,
          to: "/dashboard/booking/travel",
          permissionNo: "v515",
          active: true
        }
      ]
    },
    {
      // A leaf, not a group: there is one user dashboard, and wrapping a single
      // entry in an expandable parent adds a click for nothing.
      name: "User sessions",
      icon: FaUsers,
      to: "/dashboard/users",
      permissionNo: "v516",
      active: true
    }
    // ── Future dashboard domains (add as sibling groups) ──
    // {
    //   name: "ERP",
    //   icon: "boxes",
    //   active: true,
    //   children: [
    //     { name: "Overview", to: "/dashboard/erp", permissionNo: "vXXX", active: true }
    //   ]
    // },
    // { name: "Logistics", icon: "truck", active: true, children: [ /* … */ ] },
    // { name: "HR",        icon: FaUsers, active: true, children: [ /* … */ ] },
  ]
};

export const bookingRoutes = {
  label: "Booking",
  children: [
    {
      name: "Meeting room",
      icon: FaCalendarAlt,
      to: "/booking/meeting-room",
      active: true
    },
    {
      name: "Car",
      icon: FaCar,
      permissionNo: "v402",
      active: true,
      children: [
        {
          name: "New booking",
          icon: FaCalendarPlus,
          to: "/booking/car/new-car-booking",
          permissionNo: "v402",
          active: true
        },
        {
          name: "Booking list",
          icon: FaListUl,
          to: "/booking/car/list",
          permissionNo: "v402",
          active: true
        },
        {
          name: "Calendar",
          icon: FaCalendarAlt,
          to: "/booking/car/calendar",
          permissionNo: "v402",
          active: true
        },
        {
          name: "Settings",
          icon: FaCog,
          permissionNo: "v503",
          active: true,
          children: [
            {
              name: "Car",
              icon: FaCarSide,
              to: "/booking/car/settings/cars",
              permissionNo: "v503",
              active: true
            },
            {
              name: "Driver",
              icon: FaIdCard,
              to: "/booking/car/settings/drivers",
              permissionNo: "v503",
              active: true
            }
          ]
        }
      ]
    },
    {
      name: "Travel",
      icon: FaPlane,
      permissionNo: "v503",
      active: true,
      children: [
        {
          name: "New booking",
          icon: FaPlaneDeparture,
          to: "/booking/travel/new-travel-request",
          permissionNo: "v503",
          active: true
        },
        {
          name: "Booking list",
          icon: FaListUl,
          to: "/booking/travel/list",
          permissionNo: "v503",
          active: true
        },
        {
          name: "Calendar",
          icon: FaCalendarAlt,
          to: "/booking/travel/calendar",
          permissionNo: "v503",
          active: true
        },
        {
          name: "Settings",
          icon: FaCog,
          permissionNo: "v503",
          active: true,
          children: [
            {
              name: "Expense policy",
              icon: FaMoneyCheckAlt,
              to: "/booking/travel/settings/expense-policy",
              permissionNo: "v503",
              active: true
            },
            {
              name: "Approval flow",
              icon: FaProjectDiagram,
              to: "/booking/travel/settings/approval-flows",
              permissionNo: "v503",
              active: true
            }
          ]
        }
      ]
    }
  ]
};

export const requestUserRoutes = {
  label: "Account management",
  children: [
    {
      name: "User",
      icon: FaUser,
      permissionNo: "v402",
      active: true,
      children: [
        {
          name: "New Request",
          icon: FaUserPlus,
          to: "/request/user-accounts/new",
          permissionNo: "v402",
          active: true
        },
        {
          name: "User list",
          icon: FaListUl,
          to: "/request/user-accounts/list",
          permissionNo: "v402",
          active: true
        }
      ]
    },
    {
      name: "Terminal",
      icon: FaUserLock,
      permissionNo: "v402",
      active: true,
      children: [
        {
          name: "New Request",
          icon: FaUserPlus,
          to: "/request/terminal-accounts/new",
          permissionNo: "v402",
          active: true
        },
        {
          name: "Terminal list",
          icon: FaListUl,
          to: "/request/terminal-accounts/list",
          permissionNo: "v402",
          active: true
        }
      ]
    }
  ]
};

export const hrRoutes = {
  label: "HR",
  children: [
    {
      name: "HR Hub",
      icon: FaUsers,
      to: "/hr",
      active: true,
      badge: {
        type: "danger",
        text: "New"
      }
    }
  ]
};

export const aiRoutes = {
  label: "AI",
  children: [
    {
      name: "ChatBot",
      icon: FaRobot,
      to: "/doc-chatbot",
      active: true,
      badge: {
        type: "danger",
        text: "New"
      },
    },
    {
      name: "Doc Search",
      icon: FaBrain,
      to: "/doc-search",
      active: true,
      permissionNo: "v1020",
      badge: {
        type: "danger",
        text: "New"
      },
    }
  ]
};

export const driveRoutes = {
  label: "Drive",
  children: [
    {
      name: "Drive",
      icon: FaGoogleDrive,
      to: "/drives/list",
      permissionNo: "v402",
      active: true
    }
  ]
};

export const erpRoutes = {
  label: "ERP",
  children: [
    {
      name: "Inventory",
      icon: FaWarehouse,
      active: true,
      children: [
        {
          name: "Items",
          icon: FaSitemap,
          to: "/erp/items",
          active: true,
          permissionNo: "v917"
        },
        {
          name: "Periods",
          icon: FaChartLine,
          to: "/erp/periods",
          active: true,
          permissionNo: "v9172"
        },
        {
          name: "Transactions",
          icon: FaVrCardboard,
          to: "/erp/inventory/transactions",
          active: true,
          permissionNo: "v9171"
        },
        {
          name: "In-Out Materials",
          icon: FaBoxes,
          to: "/erp/inventory/in-out-materials",
          active: true,
          permissionNo: "v9171"
        }
      ]
    },
    {
      name: "Procurement",
      icon: FaShoppingCart,
      active: true,
      children: [
        {
          name: "Payment Requests",
          icon: FaMoneyBillWave,
          to: "/payment-requests",
          active: true,
          permissionNo: "v960"
        },
        {
          name: "Purchase Requisitions",
          icon: FaFileInvoice,
          to: "/purchase-requests",
          active: true,
          permissionNo: "v961"
        },
        {
          name: "Purchase Orders",
          icon: FaFileContract,
          to: "/purchase-orders",
          active: true,
          permissionNo: "v962"
        }
      ]
    }
  ]
};

// export const socialRoutes = {
//   label: 'Social',
//   children: [
//     {
//       name: 'Social',
//       icon: 'share-alt',
//       to: '/social/feeds',
//       active: true
//     }
//   ]
// };

export const crmRoutes = {
  label: "CRM",
  children: [
    // ── Template ──────────────────────────────────────────────────────────────
    {
      name: "Template",
      icon: FaBookDead,
      to: "/crm/templates/list",
      permissionNo: "v1000",
      active: true
    },

    // ── Lead ("New Lead" removed — action lives in All Leads page UI) ─────────
    // {
    //   name: "Lead",
    //   icon: "leaf",
    //   active: true,
    //   permissionNo: "v600",
    //   children: [
    //     {
    //       name: "All Leads",
    //       to: "/crm/leads/list",
    //       permissionNo: "v600",
    //       active: true
    //     },
    //     {
    //       name: "Dashboard",
    //       permissionNo: "v602",
    //       to: "/crm/leads/dashboard",
    //       active: true
    //     }
    //   ]
    // },

    // ── Contact ───────────────────────────────────────────────────────────────
    {
      name: "Contact",
      icon: FaAddressBook,
      to: "/crm/contacts/list",
      permissionNo: "v701",
      active: true
    },

    // ── Customer (grouped; "Customer Checking" renamed to "Customer Verification") ──
    {
      name: "Customer",
      icon: FaIntercom,
      active: true,
      permissionNo: "v801",
      children: [
        {
          name: "Customer List",
          icon: FaListUl,
          to: "/crm/customers/list",
          permissionNo: "v801",
          active: true
        },
        {
          name: "Verification",
          icon: FaUserCheck,
          to: "/crm/customers/checking",
          permissionNo: "v801",
          active: true
        }
      ]
    },

    // ── Project ("Create new PCV" removed — action lives in Project List UI) ──
    {
      name: "Project",
      icon: FaRProject,
      permissionNo: "v900",
      active: true,
      children: [
        {
          name: "Project List",
          icon: FaListUl,
          to: "/crm/projects/list",
          permissionNo: "v900",
          active: true
        },
        {
          name: "Quotations",
          icon: FaFileInvoiceDollar,
          to: "/crm/projects/quotations",
          permissionNo: "v903",
          active: true
        },
        {
          name: "Master schedule",
          icon: FaCalendarAlt,
          to: "/crm/projects/master-schedule",
          permissionNo: "v904",
          active: true
        },
        {
          name: "Project schedule (PMD)",
          icon: FaCalendarCheck,
          to: "/crm/projects/schedule-pmd",
          permissionNo: "v908",
          active: true
        },
        {
          name: "Interactions",
          icon: FaCommentDots,
          to: "/crm/projects/interactions",
          permissionNo: "v909",
          active: true
        }
      ]
    },

    // ── Commercial (new group: Contracts & Addenda, draft check vs standard, Waivers) ─────────────────
    {
      name: "Commercial",
      icon: FaFileSignature,
      active: true,
      children: [
        {
          name: "Contracts",
          icon: FaFileContract,
          to: "/crm/contracts",
          permissionNo: "v911",
          active: true,
          // Draft Check / PIF Check live under /crm/contracts/… — match this one exactly.
          exact: true
        },
        {
          name: "Draft Check",
          icon: FaBalanceScale,
          to: "/crm/contracts/draft-check",
          permissionNo: "v919",
          active: true,
          badge: { type: "danger", text: "New" }
        },
        {
          // Proposal (Sales) vs the PIF of a chosen CO#, per building of a contract
          name: "PIF Check",
          icon: FaClipboardCheck,
          to: "/crm/contracts/pif-check",
          permissionNo: "v9211",
          active: true,
          badge: { type: "danger", text: "New" }
        },
        {
          name: "Price Matrix",
          icon: FaTable,
          to: "/crm/projects/price-matrix",
          permissionNo: "v918",
          active: true
        },
        {
          name: "Waivers",
          icon: FaHandPaper,
          to: "/crm/projects/waivers",
          permissionNo: "v910",
          active: true
        }
      ]
    },

    // Delivery
    {
      name: "Delivery",
      icon: FaTruck,
      active: true,
      //permissionNo: 'v915',
      children: [
        // ── Shipment ──────────────────────────────────────────────────────────────
        {
          name: "Shipment",
          icon: FaBoxOpen,
          active: true,
          //permissionNo: 'v915',
          children: [
            {
              name: "Shipment for jobs",
              icon: FaBox,
              to: "/crm/shipments/jobs",
              permissionNo: "v9152",
              active: true
            },
            {
              name: "Shipment Plan",
              icon: FaClipboardList,
              to: "/crm/shipments/plan",
              permissionNo: "v9153",
              active: true
            },
            {
              name: "Order intake/shipment",
              icon: FaDolly,
              to: "/crm/shipments/orders",
              permissionNo: "v9154",
              active: true
            }
          ]
        },

        // ── Logistic ──────────────────────────────────────────────────────────────
        {
          name: "Logistic",
          icon: FaRoute,
          active: true,
          //permissionNo: 'v916',
          children: [
            {
              name: "Logistic tracking",
              icon: FaMapMarkedAlt,
              to: "/crm/logistics/tracking",
              permissionNo: "v9161",
              active: true
            }
          ]
        },
      ]
    },

    // ── Post-Sales (new group: Warranty + Forecast) ───────────────────────────
    {
      name: "Post-Sales",
      icon: FaShieldAlt,
      active: true,
      children: [
        {
          name: "Warranty",
          icon: FaCertificate,
          to: "/crm/projects/warranties",
          permissionNo: "v905",
          active: true
        },
        {
          name: "Forecast",
          icon: FaChartLine,
          active: true,
          permissionNo: "v1100",
          children: [
            {
              name: "Sales Release",
              icon: FaDollarSign,
              to: "/crm/release-forecast/sales",
              permissionNo: "v1101",
              active: true
            },
            {
              name: "CSD Release",
              icon: FaClipboardCheck,
              to: "/crm/release-forecast/csd",
              permissionNo: "v1102",
              active: true
            },
            {
              name: "Planning Release",
              icon: FaTasks,
              to: "/crm/release-forecast/planning",
              permissionNo: "v1112",
              active: true
            }
          ]
        }
      ]
    },

    // ── Reports (consolidated: +Master schedule +PMD; typo fixed) ─────────────
    {
      name: "Reports",
      icon: FaFlag,
      permissionNo: "v913",
      active: true,
      children: [
        {
          name: "PIF",
          icon: FaFileAlt,
          to: "/crm/reports/pifs",
          permissionNo: "v906",
          active: true
        },
        {
          name: "ICCC",
          icon: FaClipboardList,
          to: "/crm/reports/iccc",
          permissionNo: "v907",
          active: true
        },
        {
          name: "Master summary",
          icon: FaTable,
          to: "/crm/reports/project-master-summary",
          permissionNo: "v9131",
          active: true
        },
        {
          name: "Project schedule - OE",
          icon: FaCalendarAlt,
          to: "/crm/reports/project-schedule-order-entry",
          permissionNo: "v9132",
          active: true
        },
        {
          name: "Estimate assignment schedule",
          icon: FaTasks,
          to: "/crm/reports/estimate-assignment-schedule",
          permissionNo: "v9133",
          active: true
        },
        {
          name: "Engineering job progress",
          icon: FaChartLine,
          to: "/crm/reports/engineering-job-progress",
          permissionNo: "v9134",
          active: true
        },
        {
          name: "Shop by change order",
          icon: FaEdit,
          to: "/crm/reports/project/shop-by-change-order",
          permissionNo: "v9135",
          active: true
        },
        {
          name: "Shop summary",
          icon: FaClipboard,
          to: "/crm/reports/project/shop-summary",
          permissionNo: "v9136",
          active: true
        }
      ]
    },

    // ── Sales unit (configuration — placed at bottom) ─────────────────────────
    {
      name: "Configuration",
      icon: FaUniversalAccess,
      permissionNo: "v912",
      active: true,
      children: [
        {
          name: "Sales unit",
          icon: FaSitemap,
          to: "/crm/sales-units/list",
          permissionNo: "v912",
          active: true
        }
      ]
    },

  ]
};

export const organizationRoutes = {
  label: "Organization",
  children: [
    {
      name: "Employees",
      icon: FaUsers,
      to: "/organization/employees",
      permissionNo: "v100",
      active: true
    },
    {
      name: "Org chart",
      icon: FaSitemap,
      to: "/organization/employees/org-chart",
      permissionNo: "v100",
      active: true
    },
    {
      name: "Departments",
      icon: FaBuilding,
      to: "/organization/departments",
      permissionNo: "v101",
      active: true
    },
    {
      name: "Sites",
      icon: FaBuilding,
      to: "/organization/sites",
      permissionNo: "v102",
      active: true
    },
    {
      name: "Position group",
      icon: FaUserFriends,
      to: "/organization/position-groups",
      permissionNo: "v103",
      active: true
    }
  ]
};

export const authorizationRoutes = {
  label: "Authorization",
  children: [
    {
      name: "User",
      icon: FaUser,
      to: "/authorization/users",
      permissionNo: "v201",
      active: true
    },
    {
      name: "Role",
      icon: FaUserShield,
      to: "/authorization/roles",
      permissionNo: "v202",
      active: true
    },
    {
      name: "Permission",
      icon: FaUserAstronaut,
      to: "/authorization/permissions",
      permissionNo: "v203",
      active: true
    },
    {
      name: "Feature Flags",
      icon: FaFlag,
      to: "/authorization/feature-flags",
      permissionNo: "v205",
      active: true
    },
    {
      name: "Audit Logs",
      icon: FaHistory,
      to: "/authorization/audit-logs",
      permissionNo: "v518",
      active: true
    },
    {
      name: "AI Extractions",
      icon: FaRobot,
      to: "/document/extractions",
      permissionNo: "v9500",
      active: true
    },
    {
      name: "Report",
      permissionNo: "v204",
      active: true,
      icon: FaFlag,
      children: [
        {
          name: "Role permissions",
          to: "/authorization/report/role-user-permissions",
          permissionNo: "v204",
          active: true
        }
      ]
    }
  ]
};

export const jobRoutes = {
  label: "Background job",
  children: [
    {
      name: "Sidekiq",
      icon: FaBell,
      to: "/sidekiq",
      permissionNo: "v301",
      active: true
    }
  ]
};

export const integrationRoutes = {
  label: "Integration",
  children: [
    {
      name: "Integration",
      icon: FaPlug,
      to: "/integration/applications/list",
      permissionNo: "v302",
      active: true
    }
  ]
};

export const settingsRoutes = {
  label: "Settings",
  children: [
    {
      name: "Settings",
      icon: FaTools,
      to: "/settings",
      permissionNo: "v303",
      active: true
    }
  ]
};

export const documentationRoutes = {
  label: "documentation",
  children: [
    {
      name: "Faq",
      icon: FaQuestionCircle,
      to: "/documentation/faqs",
      permissionNo: "v305",
      active: true
    },
    {
      // No permissionNo → always visible (public for every user), even though the
      // Documentation group lives in protectedRoutes so Faq's v305 can gate it.
      name: "Changelog",
      icon: FaCodeBranch,
      to: "/documentation/changelog",
      active: true
    },
    {
      name: "User Guide",
      icon: FaBookOpen,
      to: "/documentation/user-guide",
      active: true
    }
  ]
};

export const tournamentRoutes = {
  label: "Sports",
  children: [
    {
      name: "Tournaments",
      icon: FaTrophy,
      to: "/sports/tournament",
      permissionNo: "v307",
      active: true
    }
  ]
};

// ── My productivity hub (Calendar + Inbox) ────────────────────────────────────
export const myRoutes = {
  label: 'My',
  children: [
    {
      name:   'My Calendar',
      icon: FaCalendarAlt,
      to:     '/my/calendar',
      active: true,
      badge: {
        type: "danger",
        text: "New"
      },
    },
    {
      name:       'My Inbox',
      icon: FaInbox,
      to:         '/my/inbox',
      active:     true,
      // Reads state.my_inbox.unreadCount from Redux — shows badge for unread only
      badgeStore: 'my_inbox.unreadCount',
      badge: {
        type: "danger",
        text: "New"
      },
    },
  ],
};

export const publicRoutes = [
  { ...bookingRoutes, sequence: 1 },
  { ...hrRoutes, sequence: 2 },
  // AI + Drive sit immediately after HR (2.1/2.2 place them between HR and
  // Account management, since the sidebar sorts all sections by `sequence`).
  { ...aiRoutes, sequence: 2.1 },
  { ...driveRoutes, sequence: 2.2 },
  { ...requestUserRoutes, sequence: 3 }
];

export const protectedRoutes = [
  { ...myRoutes,        sequence: 0 },
  { ...dashboardRoutes, sequence: 1 },
  { ...erpRoutes,       sequence: 2 },
  { ...crmRoutes,       sequence: 4 },
  { ...organizationRoutes, sequence: 5 },
  { ...authorizationRoutes, sequence: 6 },
  // Sports > Tournaments is gated by feature flag v307 — must sit in
  // protectedRoutes so filterMenusByPermissions honors permissionNo (a `hidden`
  // flag sends v307:false → child filtered out → whole "Sports" section hidden).
  // Documentation lives here (not publicRoutes) so filterMenusByPermissions honors
  // permissionNo — Faq (v305) is gated by its feature flag; Changelog / User Guide
  // have no code so they always show (keeping the section visible). Placed before
  // Sports per menu ordering.
  { ...documentationRoutes, sequence: 6.2 },
  { ...tournamentRoutes, sequence: 6.5 },
  { ...jobRoutes, sequence: 7 },
  { ...integrationRoutes, sequence: 8 },
  { ...settingsRoutes, sequence: 9 }
];
